import { Component, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { InLineErrorMessages } from '../../_shared/constants/error-messages.constant';
import { ErrorHandlerService } from '../../_shared/services/error-handler.service';
import { AuthService } from '../../_shared/services/auth.service';
import { LoginService } from '../../_shared/services/login.service';
import { Response } from '../../_shared/models';
import { NgIf } from '@angular/common';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-forgot-password-form',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    TranslocoDirective
  ],
  templateUrl: './forgot-password-form.component.html',
  styleUrl: './forgot-password-form.component.scss'
})
export class ForgotPasswordFormComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);
  private readonly errorHandler = inject(ErrorHandlerService);
  @ViewChild('requestNewPasswordForm') requestNewPasswordForm!: NgForm;
  @Output() toggleForgotPasswordForm: EventEmitter<any> = new EventEmitter<any>();
  @BlockUI() blockUI!: NgBlockUI;
  inlineErrorMessage: string;

  formSubmitted: boolean = false;
  user = {
    username: '',
    password: '',
  }

  constructor(
    private loginService: LoginService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void { }

  public requestNewPassword(): void {
    this.formSubmitted = true;
    this.inlineErrorMessage = '';

    this.blockUI.start();
    if (!this.requestNewPasswordForm.valid) {
      this.blockUI.stop();
      return;
    }

    this.loginService.requestNewPassword(this.user.username).subscribe({
      next: (response: Response<string>) => {
        this.toggleForgotPassword();
        this.blockUI.stop();
        this.toastr.success(this.transloco.translate('login.resetSuccessMessage'), this.transloco.translate('login.resetSuccessTitle'));
      },
      error: (error: any) => {
        this.handleError(error)
        this.blockUI.stop();
      }
    });
  }

  public toggleForgotPassword(): void {
    this.toggleForgotPasswordForm.emit(false);
  }

  public onUsernameChange(event: Event): void {
    if (this.inlineErrorMessage) {
      this.inlineErrorMessage = '';
    }
  }

  private handleError(error: any): void {
    const code = error?.error?.errorCode;
    this.inlineErrorMessage = InLineErrorMessages[code] ? this.transloco.translate(`inlineErrorMessages.${code}`) : '';
    if (!this.inlineErrorMessage) {
      const message = this.errorHandler.getMessage(code) || this.transloco.translate('login.loginError');
      this.toastr.error(message);
    }
  }
}